"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateProductRequestDtoDefaultLanguageEnum = exports.CreateProductRequestDtoInsuredObjectTypesEnum = void 0;
exports.CreateProductRequestDtoInsuredObjectTypesEnum = {
    Default: 'default',
    Car: 'car',
    Tpl: 'tpl',
    Custom: 'custom',
    Motorbike: 'motorbike',
    Moped: 'moped',
    Bike: 'bike',
    HomeContents: 'homeContents',
    LegalProtection: 'legalProtection',
    Accident: 'accident',
    Travel: 'travel',
    Device: 'device'
};
exports.CreateProductRequestDtoDefaultLanguageEnum = {
    German: 'German',
    English: 'English',
    Polish: 'Polish',
    French: 'French',
    Italian: 'Italian',
    Spanish: 'Spanish',
    Portuguese: 'Portuguese',
    Russian: 'Russian',
    Japanese: 'Japanese',
    Chinese: 'Chinese',
    Korean: 'Korean',
    Turkish: 'Turkish',
    Arabic: 'Arabic',
    Hindi: 'Hindi',
    Indonesian: 'Indonesian',
    Thai: 'Thai',
    Vietnamese: 'Vietnamese',
    Persian: 'Persian',
    Ukrainian: 'Ukrainian'
};
